<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import autofit from 'autofit.js'
import { isTokenValid } from '@/utils/auth.js'
import store from '@/store'
export default {
  mounted() {
    // 是否竖屏
    let isPortrait = false
    const path = this.$route.path //不加?后的参数
    if (path === '/') {
      isPortrait = true
    }
    if (path.includes('/pages/home/')) {
      isPortrait = true
    }
    if (path.includes('/pages/digi/')) {
      isPortrait = true
    }
    if (path.includes('/pages/face/')) {
      isPortrait = true
    }
    if (isPortrait) {
      // 竖屏
      autofit.init({
        dh: 1920,
        dw: 1080,
        renderDom: '#app',
        resize: true
      })
    } else {
      // 横屏
      autofit.init({
        designHeight: 1080,
        designWidth: 1920,
        renderDom: '#app',
        resize: true
      })
    }
  },
  watch: {
    $route(to, from) {
      // console.log('App watch $route', to, from)
      store.dispatch('root/set_route', to.fullPath)
    }
  },
  onLaunch: async function (options) {
    // 初始化时，校验token缓存
    // 如果token已过期，则清空storage
    const token = this.$store.getters.token
    if (token) {
      const isValid = isTokenValid(token)
      if (!isValid) {
        this.$store.dispatch('root/clear')
      }
    }

    // 初始化音量
    await this.$store.dispatch('root/init_volume')
  },
  onShow: function () {
    // console.log('App Show')
    // console.log('App Show')
    const route = this.$route
    // console.log('App watch $route', route)
    store.dispatch('root/set_route', route.fullPath)
  },
  onHide: function () {
    // console.log('App Hide')
  }
}
</script>